import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Session } from '../types/session';
import { AppConfigService } from '../../app.config';

@Injectable({
    providedIn: 'root',
})
export class UserSessionService {
    private sessionKey = 'session';
    private cachedSession$ = new ReplaySubject<Session>(1);

    /**
     * Observable of the current user session.
     */
    session$ = this.cachedSession$.asObservable();

    constructor(private configService: AppConfigService) {}

    /**
     * @see AppConfigService.getConfig
     */
    get configs() {
        return this.configService.getConfig();
    }

    /**
     * Sets the session in localstorage and sends the new session to subscribers of the session$ observable.
     * @see session$
     * @param session The newly selected session.
     */
    public setSession(session: Session) {
        const sessionJson = JSON.stringify(session);
        localStorage.setItem(this.sessionKey, sessionJson);
        this.cachedSession$.next(session);
    }
}
